import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=7b2da44a&scoped=true&"
import script from "./CardInfo.vue?vue&type=script&lang=ts&"
export * from "./CardInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=7b2da44a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2da44a",
  null
  
)

export default component.exports